import React, { useEffect, useState } from "react";
import { Collapse, Stack, Unstable_Grid2 as Grid, Box } from "@mui/material";
import TitleContribute from "@/components/pages/Community/TitleContribute";
import Projects from "@/components/pages/Community/Projects";
import PropTypes from "prop-types";
import styles from "./CodeAndDocumentation.module.scss";

const CodeAndDocumentation = ({ items }) => {
  const [selected, setSelected] = useState(false);

  useEffect(
    () => () => {
      setSelected(false);
    },
    []
  );

  return (
    <Stack sx={{ padding: { xs: 0, md: 1 } }} direction="column" useFlexGap>
      {items.map((navButtonPanelItem) => {
        const key = `CodeAndDocumentation-navButtonPanelItem-${
          navButtonPanelItem.title ?? Math.random()
        }`;
        const selectedPrefix = `${key}-option-`;
        const title =
          "Select a project group or view the [Contributor Guide](https://docs.openstack.org/contributors/?_ga=2.242117445.658299730.1762270894-1784180315.1754325175)";
        const tooltip =
          "Start with the contributor guide to get your accounts, tools, and environments setup for developing code or documentation.";

        return (
          <React.Fragment key={key}>
            <Collapse in={selected === false}>
              <TitleContribute title={title} tooltip={tooltip} />
              <Grid container columnSpacing={4} rowSpacing={2.5}>
                {navButtonPanelItem.options?.map((option) => (
                  <Grid md={4} xs={12} key={`${selectedPrefix}${option.name}`}>
                    <Box
                      onClick={() => setSelected(option.name)}
                      className={styles.contributePanelOption}
                    >
                      <div>{option.name}</div>
                      {option.text && (
                        <div className={styles.contributePanelOptionText}>
                          {option.text}
                        </div>
                      )}
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Collapse>
            <Projects
              options={navButtonPanelItem.options}
              selected={selected}
              onUnselect={() => setSelected(false)}
            />
          </React.Fragment>
        );
      })}
    </Stack>
  );
};

CodeAndDocumentation.propTypes = {
  items: PropTypes.array.isRequired
};

export default CodeAndDocumentation;
